import React from 'react';
import ConversationBubble from './ConversationBubble';
import type { PeerResponseData } from '../types';

/** Source Spines SP-2 — rich conversation bubble for a blueprint-spine reply.
 *  Now a thin wrapper over the shared SP-3a <ConversationBubble> (role="foreman");
 *  all markup + cascade + telemetry-footer logic lives there. */
const SpineConversationBubble: React.FC<{ data: PeerResponseData; index?: number }> = ({
  data,
  index = 0,
}) => (
  <ConversationBubble
    role="foreman"
    content={data.fullContent || data.content || data.preview}
    personaId={data.personaId}
    modelUsed={data.modelUsed}
    totalTokens={data.totalTokens}
    totalCostUsd={data.totalCostUsd}
    index={index}
  />
);

export default SpineConversationBubble;
